module.exports = __webpack_public_path__ + "static/media/add-product.ad33b703.svg";